
import { loaderDone, loaderStart } from "@/services/Loader";
import { Hotel } from "@/vue-core/models/Hotel.model";
import { Commodity } from "@/vue-core/models/HotelCommodities.model";
import { ref, defineComponent, onMounted, Ref, inject, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import RoomFilter from "../../components/hotels/RoomFilter.vue";
import useBreakpoints from "@/services/Breakpoints";
export default defineComponent({
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const { type } = useBreakpoints();
    const hotelID = route.params.hotelID;
    const eventID = route.params.eventID;
    const hotelDetails: Ref<Hotel | null> = ref(null);
    const emitter: any = inject("emitter");
    const today = ref(new Date().toISOString().split("T")[0]);

    const hotelDetailsInfo = (hotelData) =>
      store.dispatch("user/getHotelDetails", hotelData);

    const toggleRoomFilter = () => {
      emitter.emit("toggleRoomFilter", true);
    };

    const roomCommodities: Ref<Commodity> = ref({
      airConditioning: false,
      allInclusive: false,
      complimentaryBreakfast: false,
      fitnessCenter: false,
      freeWifi: false,
      parking: false,
    });

    function goTo(to, route) {
      router.push({ name: to, params: route });
    }

    onMounted(async () => {
      loaderStart();
      await store.dispatch("user/getEventDataExists", route.params.eventID);
      const hDetails: Hotel = await hotelDetailsInfo({
        eventID: eventID,
        hotelID: hotelID,
      });
      hotelDetails.value = hDetails;
      if (hDetails.rooms) {
        for (const room of hDetails.rooms) {
          if (room.commodities) {
            for (const keyCommodities in room.commodities) {
              if (
                Object.prototype.hasOwnProperty.call(
                  room.commodities,
                  keyCommodities
                )
              ) {
                const commodity = room.commodities[keyCommodities];
                if (commodity) roomCommodities.value[keyCommodities] = true;
              }
            }
          }
        }
      }
      loaderDone();
    });
    const filterBodyContainerClasses = computed(() => {
      if (type.value === "sm") return "body-container-xs";
      return "body-container-xl";
    });
    const filterOverflowHiddenClasses = computed(() => {
      if (type.value === "sm") return "overflow-hidden-xs";
      return "overflow-hidden-xl";
    });
    const filerRoomFilterClasses = computed(() => {
      if (type.value === "sm") return "room-filter-container-xs";
      return "room-filter-container-xl";
    });
    return {
      route,
      hotelID,
      eventID,
      hotelDetailsInfo,
      hotelDetails,
      goTo,
      roomCommodities,
      toggleRoomFilter,
      today,
      filterBodyContainerClasses,
      filterOverflowHiddenClasses,
      filerRoomFilterClasses,
    };
  },
  components: {
    CoronaRoomFilter: RoomFilter,
  },
});
